import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=ca392a7e&scoped=true&"
import script from "./MemberList.vue?vue&type=script&lang=ts&"
export * from "./MemberList.vue?vue&type=script&lang=ts&"
import style0 from "./MemberList.vue?vue&type=style&index=0&id=ca392a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca392a7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VAvatar,VChip,VContainer,VDataTable,VIcon,VImg,VPagination})
